var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// import * as Sentry from "@sentry/browser";
import * as React from "react";
var ErrorFallback = /** @class */ (function (_super) {
    __extends(ErrorFallback, _super);
    function ErrorFallback(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorFallback.prototype.componentDidCatch = function (error) {
        console.error(error);
        // Sentry.captureException(error);
        this.setState({ hasError: true });
    };
    ErrorFallback.prototype.render = function () {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.props.fallback;
        }
        return this.props.children;
    };
    return ErrorFallback;
}(React.Component));
export { ErrorFallback };
